<template>
  <div class="sign-container">
    <van-nav-bar
      :title="locale == 'zh' ? '親筆簽名' : 'Lend Money'"
      left-text="返回"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="tip">
        {{
          locale == "zh"
            ? "確認您的信息無誤後，請輸入您的手寫簽名，通過後即可成功借錢！"
            : "After confirming that your information is correct, please enter your handwritten signature. After passing, you can successfully borrow money!"
        }}
      </div>
      <SignBoard @handleConfirm="loanApply" />
    </div>
  </div>
</template>

<script>
import SignBoard from "@/components/SignBoard";

export default {
  components: {
    SignBoard,
  },
  data() {
    return {
      locale: "en",
      amount: 0,
      period: 0
    };
  },
  created() {
    window.scrollTo(0,0)
    if (this.I18n.locale.indexOf("zh") != -1) {
      this.locale = "zh";
    }
    this.amount = this.$route.params.amount
    this.period = this.$route.params.period
  },
  methods: {
    navBack() {
      this.$router.go(-1)
    },
    async loanApply() {
      this.$Toast.loading({ forbidClick: true, duration: 0 });
      let data = {
        amount: this.amount,
        period: this.period,
      };
      const res = await this.$api.loanApply(data);
      if (res.code == 200) {
        this.$Toast.success("apply successful");
        setTimeout(() => {
          this.$router.replace("/loan-record");
        }, 1000);
      } else {
        this.$Toast.clear()
        this.$Dialog.alert({
          message: res.message,
          confirmButtonText: "confirm",
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.sign-container {
  background: #f7f7f7;
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    padding: 20px;
    .tip {
      margin-bottom: 20px;
    }
  }
}
</style>